import { useUserContext } from "../../../context/UserProvider"
import { filterOnConsolidateAgreement } from "../../../utils/filterOnConsolidateAgreement"

export const useFilterOnConsolidateAgreement = () => {
  const { consolidateInvoice, chosenCompany } = useUserContext()

  return filterOnConsolidateAgreement({consolidateInvoice, chosenCompany})
}
